  <app-transport-action-bar [dashboardContext]="dashboardContext" [transport]="transport" [selection]="selection"></app-transport-action-bar>